import SalesApi from '@/modules/SalesApi'

export default ({ app, $config }, inject) => {
  inject('salesApi', new SalesApi($config))
}
